import { ProfileRow } from './ProfileRow';

/** What the person may do here, read-only: roles are an admin's to change, never their own. */
export function RolesRow({ roles }: { roles: { key: string; name: string }[] }) {
  const value =
    roles.length === 0 ? (
      <span className="text-muted">None</span>
    ) : (
      <span className="flex flex-wrap gap-1.5">
        {roles.map((role) => (
          <span key={role.key} className="rounded-full bg-muted/10 px-2.5 py-0.5 text-[13px] text-fg">
            {role.name}
          </span>
        ))}
      </span>
    );
  return <ProfileRow label="Roles" value={value} action={<span className="text-[13px] text-muted">Set by an admin</span>} />;
}
